import { render, staticRenderFns } from "./liveClass.vue?vue&type=template&id=fe691c46&scoped=true&"
import script from "./liveClass.vue?vue&type=script&lang=js&"
export * from "./liveClass.vue?vue&type=script&lang=js&"
import style0 from "./liveClass.vue?vue&type=style&index=0&id=fe691c46&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe691c46",
  null
  
)

export default component.exports